// extracted by mini-css-extract-plugin
module.exports = {"dialog":"FortellisTermsOverlay_dialog__/rb88"};